import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    enforce_2fa: false,

    avatar: {
        name: '',
        type: '',
        content: '',
    },

    events: {
        'input input[name="name"]'  : 'onNameChange',
        'input input[name="email"]' : 'onEmailChange',
        'change select[name="job"]' : 'onJobChange',
        'change input[name="role"]' : 'onRoleChange',
        'click .enforce-2fa'        : 'onToggleEnforce2fa',
        'submit .user-form'         : 'submit',
        'click .password-change'    : 'passwordChange',
        'click .confirm-email'      : 'confirmEmail',
        'click .user-image-upload'  : 'selectAvatar',
        'click .user-image-remove'  : 'removeAvatar',
    },

    dom_handlers: {
        onNameChange: function(e) {
            this.checkChange();
        },

        onEmailChange: function(e) {
            this.checkChange();
        },

        onJobChange: function(e) {
            this.checkChange();
        },

        onRoleChange: function(e) {
            this.checkChange();
        },

        confirmEmail: function(e) {
            Modals.sendEmailConfirmation();
        },

        onToggleEnforce2fa: function(e) {
            this.enforce_2fa = !this.enforce_2fa;

            if (this.enforce_2fa) {
                this.$el.find('.enforce-2fa').addClass('switch-on').removeClass('switch-off');
            } else {
                this.$el.find('.enforce-2fa').addClass('switch-off').removeClass('switch-on');
            }

            this.checkChange();
        },

        submit: function(e) {
            var data = Form.getData(this.$el.find('.user-form'));
            data = _.extend({user_id: this.model.id, enforce_2fa: this.enforce_2fa}, data);

            if (data.email.match(/qq\.com/) || data.email.match(/163\.com/)) {
                UI.error('Email address not available');
                return;
            }

            var email_changed = data.email !== this.model.get('email');

            var role = this.model.get('role');

            if (Cache.app.isAdmin() && data.role) {
                role = parseInt(data.role, 10);
            }

            this.$el.find('button:submit').addClass('loading').prop('disabled', true);

            this.saveAvatar();

            Cache.app.request({
                action:  'user/update',
                data:    data,
                success: (response) => {
                    if (response.error_msg) {
                        this.$el.find('.banner-danger').text(response.error_msg).show();
                    } else {
                        this.model.set({
                            email      : data.email,
                            role       : role,
                            name       : data.name.toString(),
                            job        : data.job,
                            enforce_2fa: this.enforce_2fa,
                        });

                        if (email_changed && this.model.get('is_email_confirmed')) {
                            this.model.set('is_email_confirmed', false);
                            this.render();
                        } else {
                            this.on_success();
                        }

                        UI.success('User details updated');
                    }
                },
                complete: () => {
                    this.$el.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        },

        passwordChange: function(e) {
            e.preventDefault();
            Modals.changePassword(this.model.id);
        },

        selectAvatar: function(e) {
            e.stopPropagation();

            Util.uploadImages(1, 2, (response) => {
                if (response[0].error) {
                    UI.error(response[0].error);
                } else if (response[0].content) {
                    this.avatar = {
                        name    : response[0].name,
                        type    : response[0].type,
                        content : response[0].content
                    };

                    this.$el.find('.user-img-64').css('background-image', 'url(' + this.avatar.content + ')');
                    this.$el.find('.user-image-remove').show();
                    this.checkChange();
                }
            });
        },

        removeAvatar: function(e) {
            e.stopPropagation();

            if (this.model.get('avatar')) {
                this.avatar = {
                    name: 'delete',
                    type: 'delete',
                    content: 'delete',
                };
            } else {
                this.avatar = {
                    name: '',
                    type: '',
                    content: '',
                }
            }

            this.$el.find('.user-img-64').css('background-image', 'url(' + Util.gravatar(this.model.get('email'), 64, this.model.get('name')) + ')');
            this.$el.find('.user-image-remove').hide();
            this.checkChange();
        }
    },

    checkChange: function() {
        var is_changed = false;

        var data = Form.getData(this.$el.find('.user-form'));

        if (data.name !== this.model.get('name')) {
            is_changed = true;
        } else if (data.email !== this.model.get('email')) {
            is_changed = true;
        } else if (data.job !== this.model.get('job')) {
            is_changed = true;
        } else if (data.role !== this.model.get('role')) {
            is_changed = true;
        } else if (this.enforce_2fa !== this.model.get('enforce_2fa')) {
            is_changed = true;
        } else if (this.avatar.content !== this.model.get('avatar')) {
            is_changed = true;
        }

        this.$el.find('button:submit').prop('disabled', !is_changed);
    },


    saveAvatar: function(e) {
        if (!this.avatar.name) {
            return;
        }

        if (Cache.real_user_id) {
            Cache.app.request({
                action: 'user/updateAvatar',
                data: this.avatar,
                success: (response) => {
                    if (this.avatar.name === 'remove') {
                        this.model.set('avatar', '');
                    } else {
                        this.model.set('avatar', response.avatar_url);
                    }
                }
            });
        } else if (Cache.portal_user) {
            Cache.app.request({
                action: 'portal_user/updateAvatar',
                data: this.avatar,
                success: (response) => {
                    if (this.avatar.name === 'remove') {
                        this.model.set('avatar', '');
                    } else {
                        this.model.set('avatar', response.avatar_url);
                    }
                }
            });
        }
    },

    initialize: function(options) {
        this.model       = Cache.user.get(options.user_id);
        this.on_success  = options.on_success;

        var workspace = Cache.getDefaultWorkspace();
        var enforce_2fa = workspace ? workspace.get('enforce_2fa') : false;

        this.enforce_2fa = enforce_2fa || this.model.get('enforce_2fa');

        this.listenTo(this.model, 'change:avatar', this.renderAvatar);
    },

    renderAvatar: function() {
        this.$el.find('.user-img-64').css('background-image', 'url(' + this.model.getAvatar(64) + ')');
    },

    render: function() {
        var workspace_member = Cache.workspace_member.findWhere({user_id: this.model.id});

        var workspace = Cache.getDefaultWorkspace();
        var enforce_2fa_disabled = workspace ? workspace.get('enforce_2fa') : false;

        var openid_provider = false;
        var openid_icon = '';
        var openid_title = '';
        if (this.model.get('google_signin')) {
            openid_provider = 'google';
            openid_icon = Svg_Icon.google;
            openid_title = 'Signed in via Google';
        } else if (this.model.get('microsoft_signin')) {
            openid_provider = 'microsoft';
            openid_icon = Svg_Icon.microsoft;
            openid_title = 'Signed in via Microsoft';
        } else if (this.model.get('sso_signin')) {
            openid_provider = 'sso';
            openid_icon = '<span class="icon text-icon"><i class="fa-solid fa-key"></i></span>';//Svg_Icon.sso;
            openid_title = 'Signed in via SSO';
        }


        var can_email_change = (!Cache.account.get('appsumo') || !workspace_member.get('is_owner'));
        var can_password_change = this.model.get('has_password');

        var content =
        '<div class="float-left">' +
            '<div class="user-profile-avatar">' +
                (Cache.real_user_id === this.model.id ?
                '<div class="user-image-remove"><i class="fa-solid fa-times"></i></div>' : '') +
                '<div class="user-img-64" style="background-image:url(' + this.model.getAvatar(64) + ');">' +
                    (Cache.real_user_id === this.model.id ?
                    '<div class="user-image-upload"><i class="fas fa-camera"></i></div>' : '') +
                '</div>' +
            '</div>' +
        '</div>' +
        '<form class="user-form form-fluid margin-left-96">' +
            '<div class="banner-danger" style="display:none;"></div>' +
            '<div class="row">' +
                '<div class="field-label">Email</div>' +
                (openid_provider ?
                '<div class="input-icon tooltip" data-title="'+ openid_title +'">' +
                    openid_icon +
                    '<input type="email" name="email" maxlength="255" required>' +
                '</div>' :
                '<input type="email" class="solid medium" name="email" maxlength="255" required>') +
                (can_email_change ? '' :  '<div class="info margin-top-8 text-small">Contact <a class="info help" href="mailto:support@userback.io">support@userback.io</a> to change your email address.</div>') +
                (this.model.id === Cache.real_user_id && !this.model.get('is_email_confirmed') ?
                '<div class="margin-top-4"><a class="confirm-email warning text-medium" href="#"><i class="fas fa-exclamation-circle margin-right-4"></i>Confirm my email address</a></div>' : '') +
            '</div>' +
            (can_password_change ?
                '<div class="row">' +
                    '<div class="field-label">' +
                        'Password' +
                        '<a href="#" class="password-change float-right">Change</a>' +
                    '</div>' +
                    '<input type="password" class="solid medium" value="....................">' +
                '</div>' : '') +
            '<div class="row">' +
                '<div class="field-label">Full Name</div>' +
                '<input type="text" class="solid medium" name="name" maxlength="100" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Job</div>' +
                '<select name="job" class="solid medium">' +
                    '<option value="">Select</option>' +
                    '<option value="designer">Designer</option>' +
                    '<option value="developer">Developer</option>' +
                    '<option value="website_owner">Website Owner</option>' +
                    '<option value="product_manager">Product Manager</option>' +
                    '<option value="freelancer">Freelancer</option>' +
                    '<option value="qa_tester">QA Tester</option>' +
                    '<option value="business_analyst">Business Analyst</option>' +
                    '<option value="other">Other</option>' +
                '</select>' +
            '</div>' +
            (this.model.id === Cache.real_user_id ? '' :
            '<div class="row">' +
                '<div class="field-label">Role</div>' +
                '<div>' +
                    '<input id="ur_role_1" type="radio" name="role" value="' + Constants.ADMIN + '" required>' +
                    '<label for="ur_role_1">Administrator</label>' +
                    '<input id="ur_role_2" type="radio" name="role" value="' + Constants.ASSIGNEE + '" required checked>' +
                    '<label for="ur_role_2">Collaborator</label>' +
                    '<input id="ur_role_3" type="radio" name="role" value="' + Constants.CLIENT + '" required>' +
                    '<label for="ur_role_3">Guest</label>' +
                '</div>' +
            '</div><hr>') +
            (can_password_change ?
                '<div class="row">' +
                    '<div class="field-label margin-top-32">' +
                        'Two-factor authentication (2FA)' +
                        '<button type="button" class="enforce-2fa float-right small' + (this.enforce_2fa ? ' switch-on' : ' switch-off') + '"' + (enforce_2fa_disabled ? ' disabled' : '') + '></button>' +
                    '</div>' +
                    (enforce_2fa_disabled ?
                    '<div class="text-info">2FA is enforced by your workspace admin.</div>' : '') +
                '</div>'
                : ''
            ) +
            '<div class="divider-16"></div>' +

            '<div class="sidebar-bottom">' +
                '<button type="submit" class="primary" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('.user-form'), this.model.attributes);

        if (!Cache.app.isAdmin() || workspace_member.get('is_owner') || this.model.id === Cache.real_user_id) {
            this.$el.find('.user-form input[name="role"]').prop('disabled', true);
        }

        if (!Cache.account.hasFeature('client_role')) {
            this.$el.find('input[value="' + Constants.CLIENT + '"]').prop('disabled', true);
        }

        if (!can_email_change || openid_provider) {
            this.$el.find('input[name="email"]').prop('disabled', true);
        }

        if (this.model.get('avatar')) {
            this.avatar.content = this.model.get('avatar')
        } else {
            this.$el.find('.user-image-remove').hide();
        }

        return this;
    }
})